import { __read } from "tslib";
import { useCallback } from 'react';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { DefaultHarmonyTheme } from '../model/DefaultHarmonyTheme';
import { useGetHarmonyTheme } from './useGetHarmonyTheme';
import { getHarmonyThemeData, useSetHarmonyTheme } from './useSetHarmonyTheme';
var harmonyThemeSubject = new BehaviorSubject(undefined);
export var harmonyThemeObservable = harmonyThemeSubject
    .asObservable()
    .pipe(distinctUntilChanged());
/**
 * Gets and sets the harmony theme
 * @returns A getter and setter for updating the Harmony theme in storage
 */
export var useHarmonyTheme = function () {
    var _a;
    // $TODO: Integrate useThemeMode and useThemeId here
    var harmonyTheme = useGetHarmonyTheme();
    // setHarmonyTheme
    var _b = __read(useSetHarmonyTheme(), 2), mutateHarmonyTheme = _b[0], _mutationResult = _b[1];
    var setHarmonyTheme = useCallback(function (updateHarmonyTheme) {
        harmonyThemeSubject.next(getHarmonyThemeData(harmonyTheme === null || harmonyTheme === void 0 ? void 0 : harmonyTheme.result, updateHarmonyTheme));
        // $TODO: on error for setting theme, should error dialog + log
        mutateHarmonyTheme(updateHarmonyTheme);
    }, [harmonyTheme, mutateHarmonyTheme]);
    return [(_a = harmonyTheme === null || harmonyTheme === void 0 ? void 0 : harmonyTheme.result) !== null && _a !== void 0 ? _a : DefaultHarmonyTheme, setHarmonyTheme];
};
//# sourceMappingURL=useHarmonyTheme.js.map